/**
 * Countdown block functionality.
 */
export default function countdownSection() {
  const countdownEles = document.querySelectorAll("[data-countdown]");

  countdownEles.forEach((countdownEle) => {
    const endDateTimestamp = parseInt(countdownEle.dataset.countdown);

    const endDate = new Date(endDateTimestamp);

    const timezone = (endDate.getTimezoneOffset() / 60 * -1) == 10 ? 'AEST' : 'AEDT';

    countdownEle.querySelector('.end-date').innerText += ` ${timezone}`;
    
    const countdown = setInterval(() => {
      const timeUntil = (endDate - Date.now()) / 1000;

      const newCount = {
        days: timeUntil / 86400,
        hours: timeUntil % 86400 / 3600,
        minutes: timeUntil % 3600 / 60,
        seconds: timeUntil % 60,
      }

      for (const [key, value] of Object.entries(newCount)) {
        countdownEle.querySelector(`.timer .${key} .value`).innerText = value <= 0 ? '0' : Math.floor(value);
      };

      if (timeUntil <= 0) {        
        return clearInterval(countdown);
      }
    }, 1000);
  })
}


// WEBPACK FOOTER //
// ./source/scripts/sections/countdown.js